<script>
  import { createEventDispatcher } from "svelte";
  import {
    TextField,
    Button,
    EmptyButton,
    SelectField,
    toastNotifier
  } from "@saztrek/firefly";

  import DeactivateModal from "./DeactivateModal.svelte";

  export let mode;
  export let cancelAction;

  export let code;
  export let name;

  export let brands;
  export let categories;

  export let version;

  export let buttonLabel;

  export let loading = false;

  export let brandCode;
  export let categoryCode;
  export let unitCount;
  export let weekSupply;
  export let core;

  const dispatch = createEventDispatcher();
  let listOfBrands;

  listOfBrands = brands.map((edge) => {
    const { node } = edge;
    return {
      option: `${node.code} - ${node.name}`,
      value: node.code
    };
  });

  listOfBrands.unshift({ option: "Choose Brand", value: null });

  let listOfCategories;

  listOfCategories = categories.map((edge) => {
    const { node } = edge;
    return {
      option: `${node.code} - ${node.name}`,
      value: node.code
    };
  });

  listOfCategories.unshift({ option: "Choose Category", value: null });

  const regularOrCoreOptions = [
    {
      option: "Regular/Core?",
      value: null
    },
    {
      option: "Core",
      value: true
    },
    {
      option: "Regular",
      value: false
    }
  ];

  const requiredFieldsFilled = () => {
    return !!(
      code &&
      name &&
      brandCode &&
      categoryCode &&
      core !== null &&
      !Number.isNaN(parseInt(unitCount, 10))
    );
  };

  const submitForm = () => {
    if (requiredFieldsFilled()) {
      if (mode === "add") {
        dispatch("validSKU", {
          code: code.trim(),
          name: name.trim(),
          brandCode: brandCode.trim(),
          categoryCode: categoryCode.trim(),
          unitCount: parseInt(unitCount, 10),
          weekSupply: parseInt(weekSupply, 10),
          core
        });
      } else {
        dispatch("validSKU", {
          code: code.trim(),
          name: name.trim(),
          version,
          brandCode: brandCode.trim(),
          categoryCode: categoryCode.trim(),
          unitCount: parseInt(unitCount, 10),
          weekSupply: parseInt(weekSupply, 10),
          core
        });
      }
    } else {
      toastNotifier.warning(
        "Required fields.",
        "Please fill in required fields",
        7000
      );
    }
  };

  const inactivateSKU = () => {
    dispatch("inactivateSKU", { code });
  };

  const resolveReadOnly = () =>
    mode === "edit" ? { readonly: true } : undefined;
</script>

{#if mode === 'edit'}
  <div class="w-full text-right pr-12">
    <DeactivateModal skuCode={code} confirmEvent={inactivateSKU} />
  </div>
{/if}
<form on:submit|preventDefault={submitForm}>
  <div class="p-4 w-full">
    <TextField
      bind:textValue={code}
      {...resolveReadOnly()}
      placeholder="Code..."
      type="text"
      label="Code" />
  </div>
  <div class="p-4 w-full">
    <TextField
      bind:textValue={name}
      placeholder="Name..."
      type="text"
      label="Name" />
  </div>
  <div class="p-4 w-full">
    <SelectField bind:value={brandCode} options={listOfBrands} label="Brand" />
  </div>
  <div class="p-4 w-full">
    <SelectField
      bind:value={categoryCode}
      options={listOfCategories}
      label="Category" />
  </div>
  <div class="p-4 w-full">
    <TextField
      bind:textValue={unitCount}
      placeholder="Unit Count..."
      type="number"
      label="Unit Count" />
  </div>
  <div class="p-4 w-full">
    <TextField
      bind:textValue={weekSupply}
      placeholder="Week Supply..."
      type="number"
      label="Week Supply" />
  </div>
  <div class="p-4 w-full">
    <SelectField
      bind:value={core}
      options={regularOrCoreOptions}
      label="Choose an option" />
  </div>
  {#if mode === 'edit'}
    <input type="hidden" bind:value={version} />
  {/if}
  <div class="w-full flex flex-row-reverse justify-evenly pb-2 mt-8 px-4">
    <Button text={buttonLabel} color="primary" type="submit" {loading} />
    <div class="w-25" />
    <div class="text-center">
      <EmptyButton text="Cancel" color="text" on:click={cancelAction} />
    </div>
  </div>
</form>
